export default {
    title: "Casa",
    button: {
        accessories: "Sfoglia il catalogo"
    },
    noAvailableItems: "Il portale periferico non ha articoli disponibili per il tuo paese in questo momento. Collabora con il tuo manager per procurarti gli articoli di cui hai bisogno.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Contatta il supporto</a>",
    error: "Si è verificato un problema durante il recupero dei prodotti. Per favore, ricarica il browser."
}